import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';

export const uploadLoaders = getLoaders({
  getPublicUrl: {
    load: async ({ url }: { url: string }): Promise<{ url: string }> => {
      const { accessUrl } = await executeApiCall<{ accessUrl: string }>({
        path: '/uploads/access-url',

        payload: { url },
      });

      return { url: accessUrl };
    },
  },
});
